import axios from "@/api/axiosInstance";
import { UpdateStageRequest, UpdateStageResponse } from "./types";

export const updateStage = async (
  uuid: string,
  requestData: UpdateStageRequest,
): Promise<UpdateStageResponse> => {
  const response = await axios.put<UpdateStageResponse>(
    `/api/private/admin/stages/${uuid}`,
    requestData,
  );
  return response.data;
};
